import React from 'react';
import {
  Banner,
  Page,
  // Layout,
} from '@shopify/polaris';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../../common/Helpers';

export class UnsuspendStore extends React.Component {

  render() {

    return (
      <React.Fragment>
        <Helmet>
          <title>Tag Genie - Reactivate</title>
        </Helmet>
        <Page title="Reactivate">
          <Banner
            title="Store connection suspended"
            status="critical"
            action={{ content: 'Reactivate Tag Genie', onAction: () => { this.unsuspendStore(); } }}>
            <p>
              Due to inactivity the connection to your store has been temporarily suspended. Please click the button to reactivate Tag Genie.
            </p>
          </Banner>
        </Page>
      </React.Fragment>
    );
  }

  unsuspendStore = () => {
    fetch('api/storeConnections/unsuspend', { 'method': "POST" })
      .then(() => { this.props.onUnsuspend() });
  }
}

export default UnsuspendStore;